/**
 * /quiz-buzzer — entry: who is this device? The host (with phones, or with
 * keys / touch zones on this one device), or a player who came by the QR
 * (?room=code) or typed the code.
 */
import { t, $, load, store, stage, PREFIX } from './util.js';
import { PRESETS } from './engine.js';
import { startHost } from './host.js';
import { startPlayer } from './player.js';

const RC = window.__RoomConnect;
const start = $('qbStart');
let preset = load('preset', 'jeopardy');
if (!PRESETS[preset]) preset = 'jeopardy';

function paintPresets() {
    document.querySelectorAll('[data-spreset]').forEach(function (b) {
        const on = b.dataset.spreset === preset;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('on', on);
    });
}

function validCode(raw) {
    if (RC && RC.validateCodeDetailed) return RC.validateCodeDetailed(raw || '');
    const c = String(raw || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 8);
    return /^[a-z0-9]{6,8}$/.test(c) ? { code: c, error: null } : { code: null, error: c ? 'format' : 'empty' };
}

function asPlayer(code) {
    start.hidden = true;
    try {
        const u = new URL(location.href);
        if (u.searchParams.get('room') !== code) { u.searchParams.set('room', code); history.replaceState(null, '', u.toString()); }
    } catch (e) { /* old browser: the link still works, reload returns to the start */ }
    startPlayer({ code: code });
}

function asHost(mode, resume) {
    start.hidden = true;
    store('preset', preset);
    startHost({ mode: mode, preset: preset, resume: resume || null });
}

// ── start screen ────────────────────────────────────────────────────────────
start.addEventListener('click', function (e) {
    const b = e.target.closest ? e.target.closest('[data-spreset]') : null;
    if (b) { preset = b.dataset.spreset; store('preset', preset); paintPresets(); }
});
$('qbHostPhones').addEventListener('click', function () { asHost('phones'); });
$('qbHostLocal').addEventListener('click', function () { asHost('local'); });
$('qbJoinGo').addEventListener('click', function () {
    const r = validCode($('qbJoinCode').value);
    const err = $('qbJoinErr');
    if (r.error) { err.textContent = r.error === 'empty' ? t('code_empty') : t('code_bad'); err.hidden = false; $('qbJoinCode').focus(); return; }
    err.hidden = true;
    asPlayer(r.code);
});
$('qbJoinCode').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('qbJoinGo').click(); } });

const saved = load('host', null);
if (saved && saved.game && saved.at && Date.now() - saved.at < 12 * 3600e3) {
    const n = (saved.game.players || []).length;
    $('qbResumeInfo').textContent = saved.mode === 'phones' && saved.code
        ? t('resume_info_room', { code: String(saved.code).toUpperCase(), n: n })
        : t('resume_info_local', { n: n });
    $('qbResume').hidden = false;
    $('qbResumeBtn').addEventListener('click', function () { asHost(saved.mode === 'local' ? 'local' : 'phones', saved); });
    $('qbResumeDrop').addEventListener('click', function () {
        store('host', null);
        try { if (RC && saved.code) RC.clearHostedRoom(PREFIX, saved.code); } catch (e) { /* storage */ }
        $('qbResume').hidden = true;
    });
}

paintPresets();
const roomParam = new URLSearchParams(location.search).get('room');
const fromLink = roomParam ? validCode(roomParam) : null;
if (fromLink && fromLink.code) {
    stage('from_link');
    asPlayer(fromLink.code);
} else {
    start.hidden = false;
    stage('start');
}
if (!RC) $('qbNoNet').hidden = false;
document.documentElement.dataset.qbReady = '1';
